import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Metodo } from "../components/home/Metodo";
import { CTABand } from "../components/CTABand";

const ITEMS = [
  "Ristrutturazione completa o parziale di appartamenti e ville",
  "Rifacimento di bagni, cucine e locali",
  "Nuove tramezzature e ridistribuzione degli spazi",
  "Pareti e controsoffitti in cartongesso",
  "Intonaci, rasature e finiture",
  "Manutenzioni e piccoli interventi",
];

export default function Privati() {
  usePageMeta(
    "Ristrutturazioni per Privati in Veneto | Costruzioni Ciosko",
    "Ristrutturazioni e lavori edili per privati in Veneto: per chi vuole ristrutturare, migliorare o trasformare la propria casa."
  );
  return (
    <>
      <PageHero
        overline="Edilizia residenziale"
        lines={["Per la tua casa,", "un lavoro fatto bene"]}
        description="Per chi vuole ristrutturare, migliorare o trasformare la propria casa."
        image="/images/privati.jpg"
      />
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <Reveal>
            <h2 className="h-display text-2xl sm:text-3xl text-white">Cosa possiamo fare per te</h2>
            <p className="text-cement leading-relaxed mt-5 text-[15px] sm:text-base">
              Seguiamo ogni intervento residenziale con la stessa organizzazione di un grande cantiere: un
              sopralluogo attento, un preventivo chiaro e lavorazioni eseguite a regola d'arte, nel rispetto della
              tua casa e dei tempi concordati.
            </p>
            <ul className="mt-8 space-y-3.5">
              {ITEMS.map((it, i) => (
                <li key={i} className="flex items-start gap-3 text-sm sm:text-[15px] text-metal/85">
                  <CheckCircle2 size={17} className="text-forest-glow shrink-0 mt-0.5" /> {it}
                </li>
              ))}
            </ul>
            <Link to="/contatti" data-testid="privati-cta-button" className="btn-primary mt-9">
              Parla con noi <ArrowRight size={16} />
            </Link>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="steel-frame">
              <div className="aspect-[4/5] overflow-hidden border border-steel">
                <img src="/images/privati.jpg" alt="Interno di abitazione ristrutturata" loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1.2s]" />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
      <Metodo />
      <CTABand />
    </>
  );
}
